import { render, staticRenderFns } from "./GetAllComments.vue?vue&type=template&id=24ce857d&scoped=true"
import script from "./GetAllComments.vue?vue&type=script&lang=js"
export * from "./GetAllComments.vue?vue&type=script&lang=js"
import style0 from "./GetAllComments.vue?vue&type=style&index=0&id=24ce857d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ce857d",
  null
  
)

export default component.exports